import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { takeoverConversation as takeoverConversationAPI } from 'util/Api';

export const takeoverConversation = createAsyncThunk(
  'hvhConversationControl/takeoverConversation',
  async ({ threadId }, { rejectWithValue }) => {
    try {
      const response = await takeoverConversationAPI({ threadId });
      if (response.apiResult && response.apiResult.status === 'SUCCESS') {
        return response;
      }
      return rejectWithValue(response);
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const closeSuccessDialog = createAction('hvhConversationControl/closeSuccessDialog');
export const closeErrorDialog = createAction('hvhConversationControl/closeErrorDialog');
